export const dataHooks = {
  title: 'sidebarsectionitem-title',
  prefix: 'sidebarsectionitem-prefix',
  suffix: 'sidebarsectionitem-suffix',
  chevronRight: 'sidebarsectionitem-chevron-right',
};
